import React, {Component} from "react";
import {VideoCallState} from "../../utils/janus.utils";

export const AppContext = React.createContext({});

export default class ProviderContext extends Component {
  state = {
    login: false,
    setLogin: (value: boolean) => {
      this.setState({ login: value });
    }, 
    chatContent: null,
    setChatContent: (value: any) => {
      this.setState({ chatContent: value });
    },

    showDownload: false,
    setShowDownload: (value: boolean) => {
      this.setState({ showDownload: value });
    },
    objectAccesses: null,
    setObjectAccesses: (value: any) => {
      this.setState({ objectAccesses: value});
    },
    friendsNum: 0,
    setFriendsNum: (value: any) => {
      this.setState({ friendsNum: value });
    }, 
    requstsNum: 0,
    setRequstsNum: (value: Object) => {
      this.setState({ requstsNum: value });
    },
    requstsFromNum: 0,
    setRequstsFromNum: (value: Object) => {
      this.setState({ requstsFromNum: value });
    },
    amountGroupRequested: 0,
    setAmountGroupRequested: (value: Object) => {
      this.setState({ amountGroupRequested: value });
    },
    requstsByNum: 0,
    setRequstsByNum: (value: Object) => {
      this.setState({ requstsByNum: value });
    },
    groups: 0,
    setGroups: (value: any) => {
      this.setState({ groups: value });
    }, 
    
    tiggerLoadFriends: 0,
    setTiggerLoadFriends: (value: any) => {
      this.setState({ tiggerLoadFriends: value });
    }, 
    clickUnblock: false,
    setClickUnblock: (value: any) => {
      this.setState({ clickUnblock: value });
    }, 

    toDownloadFiles: false,
    setToDownloadFiles: (value: boolean) => {
      this.setState({ toDownloadFiles: value });
    }, 

    progressLoadFiles: [],
    setProgressLoadFiles: (value: any) => {
      this.setState({ progressLoadFiles: value });
    },

    filesToDownload: [],
    setFilesToDownload: (value: any) => {
      this.setState({ filesToDownload: value });
    },

    mapProgress: {},
    setMapProgress: (value: any) => {
      this.setState({ mapProgress: value });
    },

    newFileDownload: null,
    setNewFileDownload: (value: any) => {
      this.setState({ newFileDownload: value });
    },

    showRightMenu: false,
    setShowRightMenu: (value: boolean) => {
      this.setState({ showRightMenu: value });
    },
    
    showModalDownloadFiles: false,
    setShowModalDownloadFiles: (value: boolean) => {
      this.setState({ showModalDownloadFiles: value });
    },
    hideArrow: false,
    setHideArrow: (value: boolean) => {
      this.setState({ hideArrow: value });
    },

    initFirebase: false,
    setInitFirebase: (value: boolean) => {
      this.setState({ initFirebase: value });
    },    downloadFiles: [],
    setDownloadFiles: (value: boolean) => {
      this.setState({ downloadFiles: value });
    },
    showHeader: false,
    setShowHeader: (value: boolean) => {
      this.setState({ showHeader: value });
    },
    showBarOnTopBarChat: false,
    setShowBarOnTopBarChat: (value: boolean) => {
      this.setState({ showBarOnTopBarChat: value });
    },
    innerWidth: false,
    setInnerWidth: (value: boolean) => {
      this.setState({ innerWidth: value });
    },
    isShowChatList: true,
    setShowChatList: (value: boolean) => {
      this.setState({ isShowChatList: value });
    },
    setInitForMainChat: () => {
      this.setState({ usedSearch: false });
    },
    usedSearch: false,
    setUsedSearch: (value: boolean) => {
      this.setState({ usedSearch: value });
    },
    group: null,
    setGroup: (value: Object) => {
      this.setState({ group: value });
    },
    isNewChat: false,
    setNewChat: (value: boolean) => {
      this.setState({ isNewChat: value });
    },
    menuActive: null,
    setMenuActive: (value: string) => {
      this.setState({ menuActive: value });
    },
    collapedMenu: false,
    setCollapedMenu: (value: boolean) => {
      this.setState({ collapedMenu: value });
    },
    // profile: null,
    // setProfile: (value: Object) => {
    //   this.setState({ profile: value });
    // },
    /******* Conference *******/
    janusPlugin: null,
    setJanusPlugin: (janus: any) => {
      this.setState({ janusPlugin: janus });
    },
    micStats: {},
    setMicStats: (v: any) => {
      this.setState({ micStats: v });
    },
    camStats: {},
    setCamStats: (c: any) => [
      this.setState({ camStats: c })
    ],
    isConnected: false,
    setIsConnected: (c: any) => {
      this.setState({ isConnected: c });
    },
    connectionID: null,
    setConnectionID: (id: any) => {
      this.setState({ connectionID: id});
    },
    recordPlugin: null,
    setRecordPlugin: (record: any) => {
      this.setState({ recordPlugin: record });
    },
    recordStream: null,
    setRecordStream: (stream: any) => {
      this.setState({ recordStream: stream });
    },
    videoCallState: VideoCallState.Idle,
    setVideoCallState: (state: VideoCallState) => {
      console.log("set state", state)
      this.setState({ videoCallState: state });
    },
    incomingCallUser: null,
    setIncomingCallUser: (user: any) => {
      this.setState({ incomingCallUser: user });
    },
    callPayload: null,
    setCallPayload: (payload: any) => {
      this.setState({ callPayload: payload })
    },
    canceledPayload: null,
    setCanceledPayload: (payload: any) => {
      this.setState({ canceledPayload: payload });
    },
    rejectedPayload: null,
    setRejectedPayload: (payload: any) => {
      this.setState({ rejectedPayload: payload });
    },
    incomingCall: false,
    setIncomingCall: (incoming: boolean) => {
      this.setState( { incomingCall: incoming })
    },
    isPendingCall: false,
    setIsPendingCall: (isPending: boolean) => {
      this.setState({ isPendingCall: isPending })
    },
    checkLoadingButton: null,
    setCheckLoadingButton: (checkLoadingBt: string) => {
      this.setState({ checkLoadingButton: checkLoadingBt })
    },

    /**** QuickChat history ********/
    quickChatHistory: null,
    setQuickChatHistory: (history: any) => {
      this.setState({ quickChatHistory: history });
    },

    /**** newFriend data *********/
    newFriend: null,
    setNewFriend: (friends: any) => {
      this.setState({ newFriend: friends });
    },
    myFriends: [],
    setMyFriends: (value: any) => {
      this.setState({ myFriends: value });
    },
    myblockAccount: [],
    setMyBlockAccount: (value: any) => {
      this.setState({ myblockAccount: value });
    },
    search: null,
    setSearch: (value: any) => {
      this.setState({ search: value });
    },
    tabsFriends: null,
    setTabsFriends: (value: any) => {
      this.setState({ tabsFriends: value });
    },
    /******** actionNoti *********/
    actionCount: 0,
    setActionCount: (noti: any) => {
      this.setState({actionCount: noti});
    } ,

    actionTotal: 0,
    setActionTotal: (value: any) => {
      this.setState({actionTotal: value});
    } ,

    activeChatId: null,
    setActiveChatId: (v: any) => {
      this.setState({activeChatId: v});
    }, 

    actions: [],
    setActions: (value: any) => {
      this.setState({actions: value});
    },
    

    /******** reply chat *********/
    isSearchingReply: false,
    setIsSearchingReply: (value: boolean) => {
      this.setState({ isSearchingReply: value });
    },
    currentMessageReplyId: null,
    setCurrentMessageReplyId: (value: any) => {
      this.setState({ currentMessageReplyId: value });
    },
    distanceReply: null,
    setDistanceReply: (value: number) => {
      this.setState({ distanceReply: value });
    },
    currentMessageReplyIdOnPress: null,
    setCurrentMessageReplyIdOnPress: (value: any) => {
      this.setState({ currentMessageReplyIdOnPress: value });
    },
    isSpinnerQuickChat: false,
    setIsSpinnerQuickChat: (value: boolean) => {
      this.setState({ isSpinnerQuickChat: value });
    },

    /******** utilities *********/
    loadingOverlay: false,
    setLoadingOverlay: (value: boolean) => {
      this.setState({ loadingOverlay: value });
    },
    overlayText: "",
    setOverlayText: (value: string) => {
      this.setState({ overlayText: value})
    },
    enableBeforeUnload: false,
    setEnableBeforeUnload: (value: boolean) => {
      this.setState({ enableBeforeUnload: value });
    },
    mainMenuActive: "",
    setMainMenuActive: (value: any) => {
      this.setState({ mainMenuActive: value });
    }

    /******** post *********/
  };
  componentDidMount() {
    try {
    } catch (e) {}
  }

  render() {
    return (
      <AppContext.Provider value={this.state}>
        {this.props.children}
      </AppContext.Provider>
    );
  }
}
//@ts-ignore
ProviderContext.Consumer = AppContext.Consumer;
